import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { formatReadSettingsAdapts, FormatReadSettingsAdapter } from './format-read-settings.adapter';
import { JsonFormatReadSettings } from 'app/model/pipeline/copysource/format-read-settings/json-format-read-settings';
import {
    convertCompressionSettingsToModel,
    convertCompressionSettingsToResource
} from '../compression-read-settings/compression-read-settings.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(JsonFormatReadSettings),
    asynchronous: true,
    adapts: {
        ...formatReadSettingsAdapts
    }
})
export class JsonFormatReadSettingsAdapter extends FormatReadSettingsAdapter<
    JsonFormatReadSettings,
    Model.FormatReadSettings
> {
    protected override async _toResource(model: JsonFormatReadSettings): Promise<Model.JsonFormatReadSettings> {
        const result: Model.JsonFormatReadSettings = FormatReadSettingsAdapter.getCommonReadSettingsProperties(
            Metamodel.modelFor(JsonFormatReadSettings).name
        );
        await convertCompressionSettingsToResource(model.compressionProperties, result, this.context);

        return result;
    }

    protected override async _toModel(
        resource: Model.JsonFormatReadSettings,
        copySource: CopySource
    ): Promise<JsonFormatReadSettings> {
        const result = FormatReadSettingsAdapter.createReadSettingsWithCommonProperties(
            JsonFormatReadSettings.MODEL,
            copySource
        ) as JsonFormatReadSettings;
        await convertCompressionSettingsToModel(resource.compressionProperties, result, this.context);

        return result;
    }
}
